import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UtilityService } from "../shared/services/Utility.service";
import * as $ from 'jquery';

@Component({
  selector: 'email-request-template',
  template: require('./email-request-template.html'),
  styles: [``],
})

export class EmailRequestTemplateComponent implements OnInit, OnDestroy {
  static parameters = [HttpClient, UtilityService]
  @Input('queueType') queueType: any;
  @Input('dValue') dValue: any;

  public defaultColDef: any;
  public RequestEmailList: any;
  public RequestListcolumnDefs: any;
  public emailRequestTimeout: any;
  public gridEmailListColumnApi: any;
  public gridEmailListApi: any;
  unitInfo: any;
  rowSelectionSingle: any;

  constructor(private http: HttpClient, public utilityService: UtilityService) {
    this.http = http;
    this.utilityService = utilityService;
    this.unitInfo = JSON.parse(localStorage.getItem('permission') as any)[0];
    this.defaultColDef = {
      resizable: true,
    };
    this.rowSelectionSingle = 'single';
  }

  ngOnInit() {
    this.RequestListcolumnDefs = [
      { headerName: 'Report Name', field: 'reportName', width: 200 },
      {
        headerName: 'Mailed To',
        field: 'emailTo',
        width: 150,
        cellRenderer: (params: any) => {
          return `<span title="${this.f_chkString(
            params.value
          ).toUpperCase()}"> ${params.value ? params.value : ''} </span>`;
        },
      },
      { headerName: 'Requested', field: 'requestedAt', width: 100 },
      { headerName: 'Completed', field: 'completedAt', width: 100 },
      { headerName: 'Status', field: 'status', width: 100 },
      {
        headerName: 'Remarks',
        field: 'remarks',
        width: 150,
        cellRenderer: (params: any) => {
          return `<span title="${this.f_chkString(
            params.value
          ).toUpperCase()}"> ${params.value ? params.value : ''} </span>`;
        },
      },
      { headerName: 'ETime', field: 'executionTime', width: 60 },
      {
        headerName: 'EMsg',
        field: 'errorMsg',
        cellRenderer: (params: any) => {
          return `<span title="${this.f_chkString(
            params.value
          ).toUpperCase()}"> ${params.value ? params.value : ''} </span>`;
        },
      },
    ];
    $(function () {
      var header = $(
        'app-email-request-template .modal-header'
      ).height() as any;
      var body = $('app-email-request-template').parent().height() as any;
      var appHeight = body - header - 15 + 'px !important';
      $('app-email-request-template .modal-body .requested-email-list').attr(
        'style',
        'height:' + appHeight
      );
    });
    this.RequestEmailList = [];
    this.GetRequestedEmailDetails();
    this.emailRequestTimeout = setInterval(() => {
      this.GetRequestedEmailDetails();
    }, 5000); // 5 Second
  }

  ngOnDestroy() {
    clearTimeout(this.emailRequestTimeout);
  }

  onEmailListGridReady(params: { api: any; columnApi: any }) {
    this.gridEmailListApi = params.api;
    this.gridEmailListColumnApi = params.columnApi;
  }

  GetRequestedEmailDetails() {
    this.http
      .get(
        `/api/CommonReports/GetRequestedEmailDetails/${this.unitInfo._id}/${this.queueType}`
      )
      .subscribe((result: any) => {
        if (this.RequestEmailList.length == 0) {
          this.RequestEmailList = result;
        } else {
          const listMapID = this.RequestEmailList.map((item: any) => item.id);
          result.forEach((element: any) => {
            const index = listMapID.indexOf(element.id);
            if (index < 0) {
              this.RequestEmailList.unshift(element);
              this.gridEmailListApi.updateRowData({
                add: [element],
                addIndex: 0,
              });
            } else if (
              index >= 0 &&
              this.RequestEmailList[index].status !== element.status
            ) {
              this.RequestEmailList[index].completedAt = element.completedAt;
              this.RequestEmailList[index].status = element.status;
              this.RequestEmailList[index].errorMsg = element.errorMsg;
              this.RequestEmailList[index].reportPath = element.reportPath;
              this.RequestEmailList[index].executionTime =
                element.executionTime;
              this.gridEmailListApi.updateRowData({
                update: [this.RequestEmailList[index]],
              });
            }
          });
          const params = {
            force: true,
            suppressFlash: true,
          };
          this.gridEmailListApi.refreshCells(params);
        }
      });
  }

  f_chkString(p_value: any) {
    var Val = (p_value ? p_value.toString() : '').trim();
    return Val;
  }
}
